import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 2.667H2.667V1.333h10.666v1.334H12V4c0 1.077-.544 1.943-1.23 2.651-.468.484-1.038.93-1.616 1.349.578.419 1.148.865 1.617 1.349C11.456 10.057 12 10.923 12 12v1.333h1.333v1.334H2.667v-1.334H4V12c0-1.077.544-1.943 1.23-2.651.468-.484 1.038-.93 1.616-1.349-.578-.419-1.148-.865-1.617-1.349C4.544 5.943 4 5.077 4 4V2.667Zm1.333 0V4c0 .59.29 1.14.854 1.724.485.5 1.116.97 1.813 1.461.697-.492 1.328-.96 1.813-1.461.564-.584.854-1.134.854-1.724V2.667H5.333ZM8 8.815c-.697.492-1.328.96-1.813 1.461-.564.584-.854 1.134-.854 1.724v1.333h5.334V12c0-.59-.29-1.14-.854-1.724-.485-.5-1.116-.97-1.813-1.461Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }